import {AOverviewStateService} from "@zaeper/angular-dashboard-view-lib";
import {IApplicationsOverviewStateService} from "./i-applications-overview-state.service";

export class ApplicationsOverviewStateService extends AOverviewStateService<any> implements IApplicationsOverviewStateService {

}
